import React, { useEffect, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styles from './FlightSearchLoader.module.css';

const messages = [
  'Buscando os melhores preços para você...',
  'Analisando centenas de combinações de voos...',
  'Encontrando as melhores ofertas disponíveis...',
  'Comparando preços de diferentes companhias...',
  'Verificando promoções e descontos...',
  'Quase lá! Finalizando sua busca...',
];

const FlightSearchLoader: React.FC = () => {
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setMsgIdx(p => (p + 1) % messages.length), 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          Encontrando os <span className={styles.highlight}>melhores voos</span> para você
        </h2>

        <div className={styles.animation}>
          <DotLottieReact
            src="https://lottie.host/d400fe6d-661a-4a5f-9654-f8a253297c28/K7qe5aXsOL.lottie"
            loop
            autoplay
            style={{ width: 350, height: 350 }}
          />
        </div>

        <p className={styles.message}>{messages[msgIdx]}</p>

        <div className={styles.dots}>
          <div className={styles.dot} />
          <div className={styles.dot} />
          <div className={styles.dot} />
        </div>
      </div>
    </div>
  );
};

export default FlightSearchLoader;
